export const COMPLETE_STAGE = 'complete' as const

export const isCompleteStage = <TStage extends string | null | undefined>(
  stage: TStage,
): stage is Extract<TStage, typeof COMPLETE_STAGE> => stage === COMPLETE_STAGE
